module.exports = __webpack_public_path__ + "img/2.2-2.9e12bca2.png";